// istanbul ignore file - the components defined in this file are simple wrappers
// around the linaria css and classnames to make them more readable and maintainable
// testing these components would only confirm that the linaria css and classnames are working as expected

import classNames from 'classnames';
import { forwardRef } from 'react';
const rulesContainerCss = "r6rqvqu";
export const RulesContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rulesContainerCss, props.className)} />;
});
const ruleContainerCss = "r1u8mzts";
export const RuleContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(ruleContainerCss, props.className)} />;
});
const yearContainerCss = "y1at2xn5";
export const YearContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(yearContainerCss, props.className)} />;
});
const wrapperCss = "w7uf6qw";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");